export default "__VITE_ASSET__Cf_rrMSP__"